import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputNumber } from "primereact/inputnumber";
import React from "react";
import { T } from "services/lang/LanguageService";

interface ProductTemplateReportOptionsProps {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
}
const ProductTemplateReportOptions = ({
  currentConfig,
  setCurrentConfig,
}: ProductTemplateReportOptionsProps) => {
  return (
    <div className="flex flex-column gap-2 w-2">
      <label htmlFor="fontSize">{T("word.font-size")} (pt)</label>
      <InputNumber
        id="fontSize"
        value={currentConfig.fontSize ?? 9.5}
        onChange={e => setCurrentConfig({ ...currentConfig, fontSize: e.value ?? 0 })}
        maxFractionDigits={2}
      />
    </div>
  );
};

export default ProductTemplateReportOptions;
